import React, { useState, useEffect } from 'react';
import { Award, CheckCircle } from 'lucide-react';

const Accueil = ({ setCurrentPage, usine, produits, chiffres, certification }) => {
  const [currentSlide, setCurrentSlide] = useState(0);
  
  // Définir vos images de fond pour le slider
  const heroImages = [
    '/images/usine.jpeg', // Première image
    '/images/usine2.jpeg', // Deuxième image (à ajouter)
    '/images/usine3.jpeg'  // Troisième image (à ajouter)
  ];

  // Fonction pour obtenir l'image de produit
  const getProductImage = (nom) => {
    switch(nom) {
      case 'Acide Chlorhydrique':
        return '/images/acide-chlorhydrique.jpg';
      case 'Soude Caustique 50%':
        return '/images/hypochlorite-sodium.jpg';
      case 'Hypochlorite de Sodium':
        return '/images/soude-caustique.jpg';
      default:
        return null;
    }
  };

  // Fonction pour changer automatiquement les slides
  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentSlide((prevSlide) => (prevSlide + 1) % heroImages.length);
    }, 5000); // Change toutes les 5 secondes

    return () => clearInterval(interval);
  }, [heroImages.length]);

  // Fonction pour passer au slide suivant
  const nextSlide = () => {
    setCurrentSlide((prevSlide) => (prevSlide + 1) % heroImages.length);
  };

  // Fonction pour passer au slide précédent
  const prevSlide = () => {
    setCurrentSlide((prevSlide) => (prevSlide - 1 + heroImages.length) % heroImages.length);
  };

  // Fonction pour aller à un slide spécifique
  const goToSlide = (index) => {
    setCurrentSlide(index);
  };

  return (
    <div className="accueil">
      {/* Hero Section avec Slider */}
      <section className="hero">
        {/* Slider d'arrière-plan */}
        <div className="hero-slider">
          {heroImages.map((image, index) => (
            <div 
              key={index}
              className={`hero-slide ${index === currentSlide ? 'active' : ''}`}
              style={{
                backgroundImage: `url(${image})`,
                backgroundSize: 'cover',
                backgroundPosition: 'center',
                backgroundRepeat: 'no-repeat'
              }}
            />
          ))}
        </div>
        
        <div className="container hero-content">
          <h1 className="hero-title" style={{ textShadow: '3px 3px 6px rgba(0,0,0,0.9), 0 0 20px rgba(0,0,0,0.5)' }}>{usine.nom}</h1>
          <p className="hero-subtitle" style={{ textShadow: '2px 2px 4px rgba(0,0,0,0.8)' }}>Expert en Chimie des Chlor-Alkalis</p>
          <p className="hero-text" style={{ textShadow: '2px 2px 4px rgba(0,0,0,0.7)' }}>
            Producteur leader d'Acide Chlorhydrique, Soude Caustique et Hypochlorite de Sodium. 
            Certification ISO 9001:2015 garantissant l'excellence de nos produits.
          </p>
          <div className="hero-buttons">
            <button 
              onClick={() => setCurrentPage('produits')}
              className="btn btn-primary"
            >
              Nos Produits
            </button>
            <button 
              onClick={() => setCurrentPage('devis')}
              className="btn btn-secondary"
            >
              Demander un devis
            </button>
          </div>
        </div>

        {/* Contrôles du slider */}
        <button className="slider-btn prev" onClick={prevSlide}>
          ‹
        </button>
        <button className="slider-btn next" onClick={nextSlide}>
          ›
        </button>

        {/* Indicateurs de slide */}
        <div className="slider-indicators">
          {heroImages.map((_, index) => (
            <button
              key={index}
              className={`slider-indicator ${index === currentSlide ? 'active' : ''}`}
              onClick={() => goToSlide(index)}
              aria-label={`Aller à l'image ${index + 1}`}
            />
          ))}
        </div>
      </section>

      {/* Chiffres Clés */}
      <section className="section stats">
        <div className="container">
          <h2 className="section-title">Nitrokym en Chiffres</h2>
          <div className="stats-grid">
            {chiffres.map((chiffre, index) => (
              <div key={index} className="stat-item">
                <div className="stat-number">{chiffre.nombre}</div>
                <div className="stat-label">{chiffre.label}</div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Présentation */}
      <section className="section">
        <div className="container">
          <div className="usine-card" style={{ maxWidth: '800px', margin: '0 auto' }}>
            <div
              className="usine-image"
              style={{
                height: '300px',
                backgroundImage: 'url(/images/team-nitro.png)',
                backgroundSize: 'cover',
                backgroundPosition: 'center 20%',
                position: 'relative'
              }}
            />
            <div className="usine-content">
              <h3 className="usine-name">{usine.nom}</h3>
              <p className="usine-specialite">{usine.specialite}</p>
              <p style={{ marginBottom: '20px', lineHeight: '1.8' }}>
                Fondée en {usine.fondation} par le groupe ECI,
                 Nitrokym est une unité de production de référence spécialisée dans la chimie des chlor-alkalis,
                  dont l'expertise technique et l'engagement indéfectible envers la qualité permettent de fournir des produits chimiques essentiels à de nombreux secteurs industriels.
                   S'appuyant sur le savoir-faire de plus de 200 collaborateurs hautement qualifiés, l'entreprise garantit une production continue et performante,
                    répondant aux normes internationales les plus strictes tout en plaçant l'innovation et la fiabilité au cœur de sa mission.
              </p>
              <button 
                onClick={() => setCurrentPage('nitrokym')}
                className="btn btn-primary"
              >
                En savoir plus sur Nitrokym
              </button>
            </div>
          </div>
        </div>
      </section>

      {/* Nos Produits */}
      <section className="section" style={{ background: '#f8f9fa' }}>
        <div className="container">
          <h2 className="section-title">Nos Produits Principaux</h2>
          <div style={{
            display: 'grid',
            gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))',
            gap: '30px',
            marginTop: '40px'
          }}>
            {produits.map((produit, idx) => (
              <div 
                key={produit.nom}
                style={{
                  borderRadius: '12px',
                  overflow: 'hidden',
                  backgroundColor: 'white',
                  boxShadow: '0 4px 15px rgba(0, 0, 0, 0.1)',
                  transition: 'transform 0.3s ease, box-shadow 0.3s ease',
                  cursor: 'pointer',
                  transform: 'translateY(0)',
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.transform = 'translateY(-8px)';
                  e.currentTarget.style.boxShadow = '0 12px 30px rgba(0, 0, 0, 0.15)';
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.transform = 'translateY(0)';
                  e.currentTarget.style.boxShadow = '0 4px 15px rgba(0, 0, 0, 0.1)';
                }}
              >
                <div 
                  style={{
                    backgroundImage: `url(${getProductImage(produit.nom)})`,
                    backgroundSize: 'cover',
                    backgroundPosition: 'center',
                    backgroundRepeat: 'no-repeat',
                    height: '220px',
                    position: 'relative',
                    color: 'white',
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'center',
                    alignItems: 'center',
                    padding: '20px',
                    textAlign: 'center',
                    '&::before': {
                      content: '""',
                      position: 'absolute',
                      top: 0,
                      left: 0,
                      right: 0,
                      bottom: 0,
                      backgroundColor: 'rgba(0, 0, 0, 0.3)',
                      zIndex: 1
                    }
                  }}
                >
                  <div style={{ position: 'relative', zIndex: 2 }}>
                    <div style={{ 
                      fontSize: '14px',
                      fontWeight: '600',
                      marginBottom: '8px',
                      letterSpacing: '1px',
                      textShadow: '2px 2px 4px rgba(0,0,0,0.7)'
                    }}>
                      {produit.formule}
                    </div>
                    <h2 style={{ 
                      fontSize: '22px',
                      fontWeight: '700',
                      textShadow: '2px 2px 6px rgba(0,0,0,0.8)',
                      margin: 0
                    }}>
                      {produit.nom}
                    </h2>
                  </div>
                </div>
                <div style={{ padding: '25px' }}>
                  <div style={{ marginBottom: '15px' }}>
                    <p style={{ marginBottom: '10px', fontSize: '14px' }}>
                      <strong style={{ color: '#0A2E5C' }}>Concentration :</strong> 
                      <span style={{ marginLeft: '8px' }}>{produit.concentration}</span>
                    </p>
                    <p style={{ marginBottom: '10px', fontSize: '14px' }}>
                      <strong style={{ color: '#0A2E5C' }}>Emballage :</strong>
                      <span style={{ marginLeft: '8px' }}>{produit.emballage}</span>
                    </p>
                  </div>
                  <div style={{ 
                    backgroundColor: '#f0f4f9',
                    padding: '12px',
                    borderRadius: '8px',
                    marginBottom: '15px',
                    borderLeft: '4px solid #FF6B35'
                  }}>
                    <p style={{ fontSize: '13px', margin: 0, lineHeight: '1.5' }}>
                      <strong style={{ color: '#0A2E5C' }}>Applications :</strong>
                      <span style={{ display: 'block', marginTop: '5px', color: '#555' }}>{produit.usage}</span>
                    </p>
                  </div>
                  <button 
                    onClick={() => setCurrentPage('produits')}
                    style={{
                      width: '100%',
                      padding: '12px 16px',
                      backgroundColor: '#0A2E5C',
                      color: 'white',
                      border: 'none',
                      borderRadius: '6px',
                      fontWeight: '600',
                      fontSize: '14px',
                      cursor: 'pointer',
                      transition: 'background-color 0.3s ease',
                    }}
                    onMouseEnter={(e) => e.target.style.backgroundColor = '#FF6B35'}
                    onMouseLeave={(e) => e.target.style.backgroundColor = '#0A2E5C'}
                  >
                    Détails du produit
                  </button>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Certification ISO */}
      <section className="section">
        <div className="container">
          <div className="cert-card" style={{ maxWidth: '800px', margin: '0 auto' }}>
            <div style={{ display: 'flex', alignItems: 'center', gap: '20px', marginBottom: '25px' }}>
              <Award size={50} color="#28a745" />
              <div>
                <h3 className="cert-name">{certification.nom}</h3>
                <h4 className="cert-title">{certification.titre}</h4>
              </div>
            </div>
            <p className="cert-desc">{certification.description}</p>
            <div style={{ marginTop: '20px' }}>
              {certification.avantages.slice(0, 3).map((avantage, idx) => (
                <div key={idx} style={{ 
                  display: 'flex', 
                  alignItems: 'center', 
                  gap: '10px',
                  marginBottom: '10px'
                }}>
                  <CheckCircle size={16} color="#28a745" />
                  <span>{avantage}</span>
                </div>
              ))}
            </div>
            <button 
              onClick={() => setCurrentPage('certification')}
              className="btn btn-primary"
              style={{ marginTop: '25px' }}
            >
              Voir la certification
            </button>
          </div>
        </div>
      </section>

      {/* Call to Action */}
      <section className="hero" style={{ background: 'linear-gradient(to right, #0A2E5C, #1e3a8a)' }}>
        <div className="container">
          <h2 className="hero-subtitle">Partenaire Chimique de Confiance</h2>
          <p className="hero-text">
            Vous cherchez des produits chimiques de qualité avec une traçabilité garantie ?
            Contactez notre équipe commerciale pour discuter de vos besoins.
          </p>
          <div className="hero-buttons">
            <button 
              onClick={() => setCurrentPage('contact')}
              className="btn btn-secondary"
            >
              Nous contacter
            </button>
            <button 
              onClick={() => setCurrentPage('devis')}
              className="btn btn-primary"
            >
              Demander un devis
            </button>
          </div>
        </div>
      </section>

      {/* Ajouter le CSS pour le slider */}
      <style jsx>{`
        .hero {
          position: relative;
          overflow: hidden;
          padding: 80px 20px;
          height: 600px;
          display: flex;
          align-items: center;
          color: white;
        }
        
        .hero-slider {
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          z-index: 0;
        }
        
        .hero-slide {
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          opacity: 0;
          transition: opacity 1s ease-in-out;
        }
        
        .hero-slide.active {
          opacity: 1;
        }
        
        .hero-content {
          position: relative;
          z-index: 1;
          text-align: center;
          width: 100%;
        }
        
        .slider-btn {
          position: absolute;
          top: 50%;
          transform: translateY(-50%);
          background: rgba(255, 255, 255, 0.2);
          color: white;
          border: none;
          width: 50px;
          height: 50px;
          border-radius: 50%;
          font-size: 24px;
          cursor: pointer;
          z-index: 2;
          transition: background 0.3s;
          display: flex;
          align-items: center;
          justify-content: center;
        }
        
        .slider-btn:hover {
          background: rgba(255, 255, 255, 0.3);
        }
        
        .slider-btn.prev {
          left: 20px;
        }
        
        .slider-btn.next {
          right: 20px;
        }
        
        .slider-indicators {
          position: absolute;
          bottom: 30px;
          left: 0;
          right: 0;
          display: flex;
          justify-content: center;
          gap: 10px;
          z-index: 2;
        }
        
        .slider-indicator {
          width: 12px;
          height: 12px;
          border-radius: 50%;
          background: rgba(255, 255, 255, 0.5);
          border: none;
          cursor: pointer;
          padding: 0;
          transition: background 0.3s;
        }
        
        .slider-indicator.active {
          background: white;
          transform: scale(1.2);
        }
        
        /* Responsive */
        @media (max-width: 768px) {
          .hero {
            height: 500px;
            padding: 60px 20px;
          }
          
          .slider-btn {
            width: 40px;
            height: 40px;
            font-size: 20px;
          }
          
          .slider-btn.prev {
            left: 10px;
          }
          
          .slider-btn.next {
            right: 10px;
          }
        }
        
        @media (max-width: 480px) {
          .hero {
            height: 450px;
            padding: 40px 15px;
          }
        }
      `}</style>
    </div>
  );
};

export default Accueil;